// UI strings of the examples in Käännösasetukset (translator/SettingExample.tsx): under a setting
// an "Esimerkki" that translates one short text with the setting each way. Every output is the
// translator's own, made when the example is opened. Finnish per docs/FINNISH-STYLE.md; en has the
// same shape.
import { defineArea } from '../area';

export const trExamplesFi = {
  open: 'Esimerkki',
  loading: 'Käännetään…',
  failed: 'Esimerkkiä ei saatu käännettyä.',
  /** Kirje: the same text translated without and with letter mode. */
  letterOff: 'Ilman kirjettä',
  letterOn: 'Kirjeenä',
};

export const trExamplesEn: typeof trExamplesFi = {
  open: 'Example',
  loading: 'Translating…',
  failed: 'The example could not be translated.',
  letterOff: 'Not as a letter',
  letterOn: 'As a letter',
};

// Messages.trExamples (i18n/area.ts: collected by area-registry.ts)
export const area = defineArea('trExamples', trExamplesFi, trExamplesEn);
declare module '../area' {
  interface AreaMessages extends Record<typeof area.key, typeof trExamplesFi> {}
}
